import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getHelpSlugForPath } from '../utils/helpConfig';

const HelpContext = createContext();

export const useHelp = () => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used within HelpProvider');
  }
  return context;
};

export const HelpProvider = ({ children }) => {
  const [helpSlug, setHelpSlug] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openHelp = useCallback((slug) => {
    if (!slug) return;
    setHelpSlug(slug);
    setIsOpen(true);
  }, []);

  const openHelpForPath = useCallback((path) => {
    const slug = getHelpSlugForPath(path);
    if (slug) {
      openHelp(slug);
      return true;
    }
    return false;
  }, [openHelp]);

  const closeHelp = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      helpSlug,
      isOpen,
      openHelp,
      openHelpForPath,
      closeHelp
    }),
    [helpSlug, isOpen, openHelp, openHelpForPath, closeHelp]
  );

  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
};
